import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBFYqd05OlYk6FiyNQ9gZp31IPPlvYXIKE",
  authDomain: "al-jazi.firebaseapp.com",
  projectId: "al-jazi",
  storageBucket: "al-jazi.appspot.com",
  messagingSenderId: "757411906038",
  appId: "1:757411906038:web:67a6d5f546c0756a0c87d7"
};
// Initialize Firebase
let messaging = null
try{
  if('serviceWorker' in navigator){
    const app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  }
}
catch(error){
  console.log(error);
}
export {messaging}
